import { FormattedMessage } from 'react-intl';
import OverlayTrigger from '@rio-cloud/rio-uikit/lib/es/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/lib/es/Tooltip';

import { Product } from '@/generated/fleetAggregationServiceTypes';
import useHoverIntent from '@/hooks/useHoverIntent';
import analyticsEvents from '@/utils/analytics/AnalyticsEvents';

type EngineOilDtcTooltipProps = {
    product?: Product;
};

export const EngineOilDtcTooltip = ({ product }: EngineOilDtcTooltipProps) => {
    const [hoverRef] = useHoverIntent(1000, () => {
        if (product === Product.ServiceCareM) {
            analyticsEvents.hoverSensorSignalMSidebarCriticLow();
        } else if (product === Product.ServiceCareS) {
            analyticsEvents.hoverSensorSignalSSidebarCriticLow();
        }
    });

    return (
        <>
            <span className="margin-left-5" />
            <OverlayTrigger
                placement="right"
                overlay={
                    <Tooltip>
                        <FormattedMessage id="intl-msg:fleetstatus.diagnostics.sidebar.section.engine_oil.state.low.spn.tooltip" />
                    </Tooltip>
                }
            >
                <span ref={hoverRef} className="icon rioglyph rioglyph-info-sign text-color-dark" />
            </OverlayTrigger>
        </>
    );
};
